<div [formGroup]="parentForm">
	<div formGroupName="{{nestedFormGroupName}}">
		<mat-radio-group formControlName="option">
			<mat-radio-button value="{{AnswerOption.KEEP}}">{{ AnswerOption.KEEP | translate}}</mat-radio-button>
			<mat-radio-button value="{{AnswerOption.FIRST_CONTACT}}">{{ AnswerOption.FIRST_CONTACT | translate}}</mat-radio-button>
			<div>
				<mat-radio-button value="{{AnswerOption.FIRST_CONTACT_AND_LOWER}}">{{ AnswerOption.FIRST_CONTACT_AND_LOWER | translate}}</mat-radio-button>
				<label> ({{"please fill in below" | translate}})</label>
			</div>
			<div>
				<mat-radio-button value="{{AnswerOption.LOWER_UNTIL}}">{{ AnswerOption.LOWER_UNTIL | translate}}</mat-radio-button>
				<label> ({{"please fill in below" | translate}})</label>
			</div>
			<div>
				<mat-radio-button value="{{AnswerOption.LOWER_BY_MM}}">{{ AnswerOption.LOWER_BY_MM | translate}}</mat-radio-button>
				<label> ({{"please fill in below" | translate}})</label>
			</div>
			<div>
				<mat-radio-button value="{{AnswerOption.LIFT_BY_MM}}">{{ AnswerOption.LIFT_BY_MM | translate}}</mat-radio-button>
				<label> ({{"please fill in below" | translate}})</label>
			</div>
		</mat-radio-group>
		<mat-form-field>
			<input matInput formControlName="text">
			<mat-error>{{"please fill in" | translate}}</mat-error>
		</mat-form-field>
	</div>
</div>
